/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable */
// @ts-nocheck

import {
  handleNewBulkFileValidation,
  transformXSSIConnectionPayload,
} from "../../util/bulkUploadFileValidation";
import { parseCSV } from "./parserLibrary";

let fileReader: any;
let payload: any = [];

function handleColumnMismatch(headers: string[], csvTemplate: string[]) {
  let columnMismatched = false;
  if (
    !headers.every((field) =>
      csvTemplate[0]
        .split(",")
        .map((val) => val.trim())
        .includes(field)
    ) &&
    headers.length !== csvTemplate.length
  ) {
    columnMismatched = true;
  }
  return columnMismatched;
}

function handleMaxRowLimitReached(payload: string[][], bulkLimit: string) {
  const limit = Number.isNaN(Number(bulkLimit)) ? 1000 : Number(bulkLimit);
  return payload.length > limit;
}

interface DataObject {
  [key: string]: string; // Dynamic keys with string values
}

function csvToArrayOfObjects(
  parsedData: string[][],
  headers: string[]
): DataObject[] {
  const dataObjects: DataObject[] = [];
  const startTimeStamp = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .slice(0, -5);

  for (let i = 1; i < parsedData.length; i += 1) {
    const obj: DataObject = {};
    for (let j = 0; j < headers.length; j += 1) {
      let value =
        parsedData[i][j] !== undefined && parsedData[i][j].match("\r") !== null
          ? parsedData[i][j].replace("\r", "")
          : parsedData[i][j];

      obj[headers[j]] = value; // Map headers to values
    }
    dataObjects.push(obj);
  }
  return dataObjects;
}

export const parseChosenFile = (
  setFile: (arg0: Record<string, any>[]) => void,
  setRowCount: (arg0: number) => void,
  setErrorFile: (arg0: Record<string, any>[]) => void,
  setValidatedFile: (arg0: Record<string, any>[]) => void,
  moduleName: string,
  bulkLimit: string,
  setIsBulkLimitReached: (arg0: boolean) => void,
  setIsColumnMistached: (arg0: boolean) => void,
  csvTemplate: string[],
  data?: Array
) => {
  payload = [];
  const validationMethod = handleNewBulkFileValidation(moduleName);
  const content = fileReader.result;
  const parsedData = parseCSV(content);
  const headers = parsedData.data[0].join(",").trim().split(","); // Get headers from the first row

  payload = csvToArrayOfObjects(parsedData.data, headers);

  if (handleColumnMismatch(headers, csvTemplate)) {
    setIsColumnMistached(true);
  } else if (handleMaxRowLimitReached(payload, bulkLimit)) {
    setIsBulkLimitReached(true);
  } else {
    setFile(payload);
    setRowCount(payload.length);
    let response;
    if (moduleName === "XSSI Connection") {
      let transformedResponse = transformXSSIConnectionPayload(payload);
      response = validationMethod(transformedResponse);
    } else if (moduleName === "DFSI Channel" || moduleName === "DFSI Group") {
      response = validationMethod(payload, data);
    } else if (moduleName === "DFSI Connection") {
      response = validationMethod(payload, data);
    } else {
      response = validationMethod(payload);
    }
    const { finalFile, filewitherror } = response;
    setErrorFile(filewitherror);
    setValidatedFile(finalFile);
  }
};

export const readChosenFile = (
  file: any,
  setFile: (arg0: Record<string, any>[]) => void,
  setRowCount: (arg0: number) => void,
  setErrorFile: (arg0: Record<string, any>[]) => void,
  setValidatedFile: (arg0: Record<string, any>[]) => void,
  moduleName: string,
  bulkLimit: string,
  setIsBulkLimitReached: (arg0: boolean) => void,
  setIsColumnMistached: (arg0: boolean) => void,
  csvTemplate: string[],
  data?: Array
) => {
  fileReader = new FileReader();
  fileReader.readAsText(file);
  fileReader.onloadend = () =>
    parseChosenFile(
      setFile,
      setRowCount,
      setErrorFile,
      setValidatedFile,
      moduleName,
      bulkLimit,
      setIsBulkLimitReached,
      setIsColumnMistached,
      csvTemplate,
      data
    );
};

export const handleTabMovement = ({
  steps,
  showReport,
  fileName,
}: {
  steps: number;
  showReport: boolean;
  fileName: string;
}) => {
  let result = false;
  if (steps === 2 && showReport) {
    result = true;
  }
  if (steps === 1 && fileName) {
    result = true;
  }

  return result;
};

// Function to download the CSV file
export const downloadCSV = (data: any, reportName: string) => {
  // Create a Blob with the CSV data and type
  const blob = new Blob([data], { type: "text/csv" });

  // Create a URL for the Blob
  const url = window.URL.createObjectURL(blob);

  // Create an anchor tag for downloading
  const a = document.createElement("a");

  // Set the URL and download attribute of the anchor tag
  a.href = url;
  a.download = reportName;

  // Trigger the download by clicking the anchor tag
  a.click();
};

function escapeSpecialChars(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

// Function to create the CSV file
const csvmaker = (data: { [s: string]: unknown } | ArrayLike<unknown>) => {
  let csvLine = [];
  // Pushing Object values into array with comma separation
  csvLine = Object.values(data).map((text) => {
    let quoteChar = '"';
    let escapedQuote = quoteChar + quoteChar;
    let needsQuotes = false;
    let quotes = false;
    let delimiter = ",";
    let escapeFormulae = /^[=+\-@\t\r].*$/;
    if (typeof text === "undefined" || text === null) return "";
    if (text.constructor === Date) return JSON.stringify(text).slice(1, 25);
    if (typeof text === "string") {
      let str = text.trim();
      if (
        escapeFormulae &&
        typeof str === "string" &&
        escapeFormulae.test(str)
      ) {
        str = "'" + str;
        needsQuotes = true;
      }
      let quoteCharRegex = new RegExp(escapeSpecialChars(quoteChar), "g");
      let escapedQuoteStr = str
        .toString()
        .replace(quoteCharRegex, escapedQuote);

      needsQuotes =
        needsQuotes ||
        quotes === true ||
        (Array.isArray(quotes) && quotes[col]) ||
        escapedQuoteStr.indexOf(delimiter) > -1 ||
        escapedQuoteStr.charAt(0) === " " ||
        escapedQuoteStr.charAt(escapedQuoteStr.length - 1) === " ";
      return needsQuotes
        ? quoteChar + escapedQuoteStr + quoteChar
        : escapedQuoteStr;
    } else {
      try {
        JSON.parse(text.message);
        return Object.values(JSON.parse(text.message))[0];
      } catch (err) {
        return text;
      }
    }
  });
  return csvLine.join(",");
};

export const processErrorReport = (errorFile: Record<string, any>[] = []) => {
  let headers = [];
  let values = []; // Empty array for storing the csv rows

  // Pushing Object keys into array with comma separation
  headers = Object.keys(errorFile[0]);
  // create csv file
  const result = errorFile.map((ele: any) => csvmaker(ele));

  values.push(headers.join(","));
  values.push(...result);
  return values;
};
